export const SPANISH = {
  question: 'Cuál es tu peso ?',
  btn_leger_text: 'Leve',
  leger_info_content: `Problemas fisiológicos leves: sueño ligero, búsqueda de bienestar, relajación muscular, digestión pesada.
  Problemas psicológicos leves: necesidad de relajación, necesidad de concentración.`,
  btn_moyen_text: 'Medio',
  moyen_info_content: `Problemas fisiológicos medios: Sueño de calidad, dolores, ligeros dolores musculares, inflamación, problemas digestivos.
  Problemas psicológicos medios: Ansiedad, estrés, dificultad de concentración.`,
  btn_intensity_text: 'Potente',
  intensity_info_content: `Problemas fisiológicos: problemas de sueño, dolores intensos, dolores musculares y articulares, epilepsia y enfermedades degenerativas, dolores menstruales, anorexia.
  Problemas psicológicos: ansiedad, estrés, problemas de concentración`,
  important_text:
    'esta prueba es un consejo para calcular la dosis de CBD recomendada. De ninguna manera constituye un consejo médico o una receta.',
  powered_text: 'Preguntas ? Estamos aquí para ayudar',
  btn_calcul_text: 'Calcular',
  btn_reset_text: 'Reiniciar',
  get_calculator_text: 'Toma esta calculadora',
  btn_copy_text: 'Copiar',
  weight: 'Peso',
  trouble: 'Problema',
  recommendation_text:
    'Recomendación en número de gotas según la concentración en% del aceite comprado.',
  gout_of_day: 'Gotas por dia',
  delaide_text: 'Duración de la botella en días',
  oil: 'Aceite',
  btn_recalculate_text: 'Calcular todavía',
  important: 'Importante',
  effet_question: 'Qué efecto buscas?',
  text_alert: `El aceite de CBD no está destinado a un uso médico y no debe utilizarse con el fin de detectar, diagnosticar, tratar, curar, mitigar, prevenir, gestionar o controlar enfermedades.

  Los suplementos dietéticos y el aceite de CBD no sustituyen a una dieta variada y equilibrada y a un estilo de vida saludable.
  `,
  back_to_shop: 'Volver a la tienda',
  leger: 'Leve',
  moyen: 'Medio',
  intense: 'Potente',
};
